module.exports = __webpack_public_path__ + "img/87c3611750f5aca69438094ae3e20a82.png";